<!-- sidebar.component.html -->
<div class="sidebar" [ngClass]="{'sidebar-open': sidebarOpen, 'sidebar-closed': !sidebarOpen}">
  <div class="sidebar-header">
    <a *ngIf="sidebarOpen" href="https://www.definio.com" target="_blank">
      <img src="assets/Logo_Transparent.png" alt="Company Logo" class="sidebar-logo">
    </a>
    <i class="bi bi-list sidebar-header-icon" (click)="toggleSidebar()"></i>
  </div>
  <div class="sidebar-content">
    <a routerLink="/dashboard" routerLinkActive="active" class="sidebar-icon"><i class="bi bi-house"></i><span>Dashboard</span></a>
    <a routerLink="/search" routerLinkActive="active" class="sidebar-icon"><i class="bi bi-search"></i><span>Search</span></a>
    <a routerLink="/harmonization-data" routerLinkActive="active" class="sidebar-icon"><i class="bi bi-grid-3x3"></i><span>Harmonization&nbsp;Data</span></a>
    <div class="spacer"></div>
    <a routerLink="/profile" routerLinkActive="active" class="sidebar-icon"><i class="bi bi-person"></i><span>{{ userName || 'Profile' }}</span></a>
    <a (click)="logout()" routerLinkActive="active" class="sidebar-icon"><i class="bi bi-box-arrow-right"></i><span>Logout</span></a>
  </div>
</div>
